import * as React from 'react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';
import { getSlateEditorValue } from '@doltech/utils/lib/editor';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

import { colorsV2 } from '../../colors-v2';
import { RendererWithPlugins } from '../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ParagraphPlugin } from '../../../slatePlugins/components/core/readonly/ParagraphPlugin';
import { HeadingReadOnlyPlugin } from '../../../slatePlugins/elements/heading/HeadingReadOnlyPlugin';

const Breadcrumb = styled.div``;

const Container = styled.div`
  ${verticalSpace(20)}

  h1 {
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
    color: ${colorsV2.neutral200};

    margin-top: 0;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    color: ${colorsV2.neutral140};

    margin-top: 0;
    margin-bottom: 0;
  }

  ${fromScreen(451)} {
    h1 {
      font-size: 42px;
      line-height: 56px;
    }
  }
`;

const plugins = [
  ParagraphPlugin,
  HeadingReadOnlyPlugin(),
];

interface BlogEditorElementHeadingProps {
  breadcrumb?: React.ReactNode;
  headingValue?: string;
}

export const BlogPageElementHeading = (props: BlogEditorElementHeadingProps) => {
  const { breadcrumb, headingValue } = props;

  return (
    <Container className="blog-editor-element-heading">
      <Breadcrumb>
        {breadcrumb}
      </Breadcrumb>
      <RendererWithPlugins plugins={plugins} value={getSlateEditorValue(headingValue)} />
    </Container>
  );
};
